// src/serviceWorkerRegistration.js

export function register(config) {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
        navigator.serviceWorker.register(swUrl).then(registration => {
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                // Si hay un nuevo SW esperando (esto es una actualización), se invoca el callback
                if (navigator.serviceWorker.controller) {
                  if (config && config.onUpdate) {
                    config.onUpdate(registration);
                  }
                }
              }
            };
          };
        }).catch(error => {
          console.error('Error during service worker registration:', error);
        });
      });
    }
  }
  